import React, { useEffect, useState } from "react";
import { notification } from "antd";
import { useGetOrgIdentifier } from "../../generic/hooks/useGetOrgIdentifier";
import apiService from "../../../service/apiservice/apiService";
import MultiSelectAndSearch from "./MultiSelectAndSearch";

const TeamMultiselect = ({ data, setData, isMultiSelect, error, label, required }) => {
  const organizationIdentifier = useGetOrgIdentifier();
  const [masterTeamList, setMasterTeamList] = useState([]);

  const handleTeamsChange = (value) => {
    const filteredTeams = masterTeamList.filter((team) =>
      value.includes(team.name)
    );
    
    setData((prev) => ({ ...prev, teams: filteredTeams }));
  };

  useEffect(() => {
    const getTeamsList = async () => {
      try {
        const endpoint = `niramayafoundation/niramayaworkforce/api/v1/teams?organizationIdentifier=${organizationIdentifier}`;
        const teamResponse = await apiService.get(endpoint);

        if (!teamResponse) {
          throw new Error(`${label} response not found`);
        }
        setMasterTeamList(teamResponse);
      } catch (error) {
        notification.error({
          message: error?.message || "Something went wrong",
          placement: "bottomRight",
        });
      }
    };

    getTeamsList();
  }, [label, organizationIdentifier]);

  return (
    <>
        <MultiSelectAndSearch
          optionsData={{
            label: `${label}s`,
            value: "teams",
            menuItems: masterTeamList?.map((item) => item.name) || [],
          }}
          data={data?.teams?.map((item) => item?.name) || []}
          setData={handleTeamsChange}
          isMultiSelect={isMultiSelect}
          error={error?.teams}
          required={required}
        />
    </>
  );
};

export default TeamMultiselect;
